(function () {
  'use strict';

  class CartServices {
    static getGiftWrapItem(cart, variantId) {
      const targetVariantId = Number(variantId || 0);

      if (!targetVariantId || !Array.isArray(cart?.items)) {
        return null;
      }

      return (
        cart.items.find(function (item) {
          return Number(item.variant_id) === targetVariantId;
        }) || null
      );
    }

    static async addGiftWrap(variantId) {
      const targetVariantId = Number(variantId || 0);

      if (!targetVariantId) {
        throw new Error(
          'No gift wrapping product has been selected in Theme settings.'
        );
      }

      const cart = await window.CartApi.get();
      const existingItem = this.getGiftWrapItem(cart, targetVariantId);

      if (existingItem) {
        return cart;
      }

      await window.CartApi.add({
        items: [
          {
            id: targetVariantId,
            quantity: 1,
            properties: {
              '_Gift wrapping charge': 'Yes',
              '_trees_direct_gift_wrap': 'true'
            }
          }
        ]
      });

      return window.CartApi.get();
    }

    static async removeGiftWrap(variantId, knownKey) {
      let giftWrapKey = knownKey || '';

      if (!giftWrapKey) {
        const cart = await window.CartApi.get();
        giftWrapKey = this.getGiftWrapItem(cart, variantId)?.key || '';

        if (!giftWrapKey) {
          return cart;
        }
      }

      return window.CartApi.change(giftWrapKey, 0);
    }

    static saveGiftAttributes(isGiftWrapped, message) {
      return window.CartApi.update({
        attributes: {
          'Gift wrapping': isGiftWrapped ? 'Yes' : 'No',
          'Gift message': String(message || '').trim()
        }
      });
    }

    static saveOrderNote(note) {
      return window.CartApi.update({
        note: String(note || '').trim()
      });
    }
  }

  window.CartServices = CartServices;
})();
